import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const AuthContext = /*#__PURE__*/ createContext(undefined);
/**
 * Host-side: the shell assembles an `AuthContextValue` (state, timers,
 * broadcast channel, the works) and hands the finished value here.
 *
 * Exported instead of the raw context object on purpose — an app importing
 * the context directly could mount a second provider around a subtree, and
 * app + shell would each hold their own auth state. Handing out only this
 * component keeps `AuthProvider` (the shell's, the one place state is
 * assembled) the single mount point.
 */ export function AuthStateProvider({ value, children }) {
    return /*#__PURE__*/ _jsx(AuthContext.Provider, {
        value: value,
        children: children
    });
}
export function useAuth() {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
}
/**
 * The auth value, or undefined where no AuthProvider is mounted (a test, an
 * embedded surface). For a component that can do without the user.
 */ export function useOptionalAuth() {
    return useContext(AuthContext);
}
